import React, { useEffect, useState } from 'react';
import { Grid, TextField, Button, IconButton, Typography, Box, CircularProgress, LinearProgress } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import axios from './../../axios/api';
import toast from 'react-hot-toast';
import { PREFIX_URL } from '../../components/Constants';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const FormSinger = ({ isEdit = false, refreshData, idEdit = null, handleCloseModal, Data }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [imageName, setImageName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({ name: '', family: '', avatar: '' });
    const [LoadingButton, setLoadingButton] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    useEffect(() => {
        if (isEdit) {
            setFirstName(Data?.name);
            setLastName(Data?.family);
            if (Data?.avatar) {
                setSelectedImage(checkAndAddPrefix(Data?.avatar));
                setImageName("Edit");
            }
        }
    }, [isEdit])


    const reseteState = () => {
        setImageName('');
        setFirstName('');
        setLastName('');
        setSelectedImage(null);
    }


    const checkAndAddPrefix = (url) => {
        const prefix = PREFIX_URL;
        if (url && url.startsWith('/uploads/')) {
            return `${prefix}${url}`;
        }
        return url;
    };




    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImage(file);
            setImageName(file.name);

            // Convert selected image to base64
            const reader = new FileReader();
            reader.onloadend = () => {
            };
            reader.readAsDataURL(file);
        }
        if (errors.avatar) {
            setErrors((prevErrors) => ({ ...prevErrors, avatar: '' }));
        }
    };


    const handleRemoveImage = () => {
        setSelectedImage(null);
        setImageName('');
    };

    const handleFirstNameChange = (event) => {
        setFirstName(event.target.value);
        if (errors.name) {
            setErrors((prevErrors) => ({ ...prevErrors, name: '' }));
        }
    };

    const handleLastNameChange = (event) => {
        setLastName(event.target.value);
        if (errors.family) {
            setErrors((prevErrors) => ({ ...prevErrors, family: '' }));
        }
    };


    const UpdateArtist = async () => {
        try {
            setLoadingButton(true);

            const formData = new FormData();
            // Append the data to the FormData object
            formData.append('name', firstName);
            formData.append('family', lastName);

            if (selectedImage && imageName != "Edit") {
                formData.append('avatar', selectedImage);
            }

            // Send the base64 string using axios
            const res = await axios.post(`/admin/artist/update/${idEdit}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }, onUploadProgress: (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    setUploadProgress(percent);
                }
            });
            if (res.status === 200) {
                setUploadProgress(100);  // Set upload progress to 100% on success
            }

            toast.success(res.data?.message);
            refreshData();
            reseteState();
            handleCloseModal();
        } catch (error) {
            setUploadProgress(0);
            if (error.response?.status === 422) {
                setErrors({
                    name: error.response.data.data.name ? error.response.data.data.name[0] : '',
                    family: error.response.data.data.family ? error.response.data.data.family[0] : '',
                    avatar: error.response.data.data.avatar ? error.response.data.data.avatar[0] : '',
                });
            } else {
                toast.error(error.response?.data?.message || 'An error occurred');
            }
        } finally {
            setLoadingButton(false);
        }
    };


    const sendArtist = async () => {
        try {
            setLoadingButton(true);
            const formData = new FormData();
            // Append the data to the FormData object
            formData.append('name', firstName);
            formData.append('family', lastName);

            if (selectedImage) {
                formData.append('avatar', selectedImage);
            } else {
                formData.append('avatar', null);

            }

            // Send the base64 string using axios
            const res = await axios.post('/admin/artist/store', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }, onUploadProgress: (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    setUploadProgress(percent);
                }
            });
            if (res.status === 200) {
                setUploadProgress(100);  // Set upload progress to 100% on success
            }
            toast.success(res.data?.message);
            reseteState();

        } catch (error) {
            setUploadProgress(0);

            if (error.response?.status === 422) {
                setErrors({
                    name: error.response.data.data.name ? error.response.data.data.name[0] : '',
                    family: error.response.data.data.family ? error.response.data.data.family[0] : '',
                    avatar: error.response.data.data.avatar ? error.response.data.data.avatar[0] : '',
                });
            } else {
                toast.error(error.response?.data?.message || 'An error occurred');
            }
        } finally {
            setLoadingButton(false);
        }
    };

    const isBlobOrFile = (obj) => {
        return obj instanceof Blob || obj instanceof File;
    };

    return (
        <div dir="rtl">
            <Grid container spacing={2}>
                <Grid item lg={6} md={6} sm={12}>
                    <TextField
                        id="first-name"
                        label="نام مداح"
                        type="text"
                        variant="outlined"
                        fullWidth
                        value={firstName}
                        onChange={handleFirstNameChange}
                        error={Boolean(errors.name)}
                        helperText={errors.name}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12}>
                    <TextField
                        id="last-name"
                        label="نام خانوادگی مداح"
                        type="text"
                        variant="outlined"
                        fullWidth
                        value={lastName}
                        onChange={handleLastNameChange}
                        error={Boolean(errors.family)}
                        helperText={errors.family}
                    />
                </Grid>
                <Grid item lg={12} md={12} sm={12}>
                    <Button
                        component="label"
                        role={undefined}
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<CloudUploadIcon />}
                    >
                        <Typography variant="caption">آپلود تصویر</Typography>
                        <VisuallyHiddenInput type="file" accept="image/*" onChange={handleImageChange} />
                    </Button>
                    {errors.avatar && (
                        <Typography color="error" variant="caption" sx={{ mt: 1 }}>
                            {errors.avatar}
                        </Typography>
                    )}
                </Grid>
                {selectedImage && (
                    <Grid item lg={12} md={12} sm={12}>
                        <Box sx={{
                            position: 'relative',
                            display: 'inline-block',
                            border: '1px dashed #ccc',
                            padding: 1,
                            borderRadius: 2
                        }}>
                            <img
                                src={isBlobOrFile(selectedImage) ? URL.createObjectURL(selectedImage) : selectedImage}

                                alt="Selected Image"
                                style={{ width: 100, height: 100, borderRadius: 10 }}
                            />
                            <IconButton
                                onClick={handleRemoveImage}
                                aria-label="Remove Image"
                                size="small"
                                sx={{
                                    width: 20,
                                    height: 20,
                                    position: 'absolute',
                                    top: -5,
                                    right: -7,
                                    backgroundColor: '#EC2327',
                                    color: 'white',
                                    '&:hover': {
                                        opacity: 1,
                                    },
                                }}
                            >
                                <CloseIcon sx={{ width: 10, height: 10 }} color="black" fontSize="small" />
                            </IconButton>
                            <br />
                            <Typography variant="caption" sx={{ mt: 1 }}>
                                {imageName}
                            </Typography>
                        </Box>
                    </Grid>
                )}
                <Grid item lg={12} md={12} sm={12}>
                    {uploadProgress > 0 && uploadProgress != 100 && (
                        <Box sx={{ width: '100%', mb: 2 }}>
                            <LinearProgress variant="determinate" value={uploadProgress} />
                            <Typography variant="caption" sx={{ textAlign: 'center' }}>
                                {uploadProgress}%
                            </Typography>
                        </Box>
                    )}
                </Grid>
                <Grid item lg={12} md={12} sm={12}>
                    {isEdit ?
                        <Button
                            color="secondary"
                            fullWidth
                            variant="contained"
                            size="large"
                            onClick={UpdateArtist}
                            disabled={LoadingButton}
                        >
                            {LoadingButton && <CircularProgress size={24} color="inherit" />}

                            <Typography color="white">ویرایش مداح </Typography>
                        </Button>
                        :
                        <Button
                            color="secondary"
                            fullWidth
                            variant="contained"
                            size="large"
                            onClick={sendArtist}
                            disabled={LoadingButton}
                        >
                            {LoadingButton && <CircularProgress size={24} color="inherit" />}
                            <Typography color="white">ثبت مداح جدید</Typography>
                        </Button>
                    }
                </Grid>
            </Grid>
        </div>
    );
};

export default FormSinger;
